"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secretLayer = void 0;
const SAPPHIRE_MAINNET = 23_294;
const SAPPHIRE_TESTNET = 23_295;
exports.secretLayer = {
    mainnet: {
        chainId: SAPPHIRE_MAINNET,
        urlOrProvider: 'https://sapphire.oasis.io',
        addresses: {
            protocolForwarder: '0x7204e1B7fFa700279cb7189E73d5965FC58eBe7E',
            revShare: '0x7fF1514f26376e30aD0F028880467d6A1D61a31E',
        },
    },
    testnet: {
        chainId: SAPPHIRE_TESTNET,
        urlOrProvider: 'https://testnet.sapphire.oasis.io',
        addresses: {
            protocolForwarder: '0xba3CdfE435ba473594f469DBB0A6ADbDBe9548d0',
            revShare: '0xE7C17c7eAc5aC4DE6711F5a5A9F77a91505C991d',
        },
    },
    devnet: {
        chainId: SAPPHIRE_TESTNET,
        urlOrProvider: 'https://testnet.sapphire.oasis.io',
        addresses: {
            protocolForwarder: '0xba3CdfE435ba473594f469DBB0A6ADbDBe9548d0', // same as TESTNET
            revShare: '0xFc1742435853Ce688173cA703cD3b82480eBFa84',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VjcmV0LWxheWVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NjaGVtYS9zZWNyZXQtbGF5ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS0EsTUFBTSxnQkFBZ0IsR0FBRyxNQUFNLENBQUE7QUFDL0IsTUFBTSxnQkFBZ0IsR0FBRyxNQUFNLENBQUE7QUFFbEIsUUFBQSxXQUFXLEdBQW9EO0lBQzFFLE9BQU8sRUFBRTtRQUNQLE9BQU8sRUFBRSxnQkFBZ0I7UUFDekIsYUFBYSxFQUFFLDJCQUEyQjtRQUMxQyxTQUFTLEVBQUU7WUFDVCxpQkFBaUIsRUFBRSw0Q0FBNEM7WUFDL0QsUUFBUSxFQUFFLDRDQUE0QztTQUN2RDtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsT0FBTyxFQUFFLGdCQUFnQjtRQUN6QixhQUFhLEVBQUUsbUNBQW1DO1FBQ2xELFNBQVMsRUFBRTtZQUNULGlCQUFpQixFQUFFLDRDQUE0QztZQUMvRCxRQUFRLEVBQUUsNENBQTRDO1NBQ3ZEO0tBQ0Y7SUFDRCxNQUFNLEVBQUU7UUFDTixPQUFPLEVBQUUsZ0JBQWdCO1FBQ3pCLGFBQWEsRUFBRSxtQ0FBbUM7UUFDbEQsU0FBUyxFQUFFO1lBQ1QsaUJBQWlCLEVBQUUsNENBQTRDLEVBQUUsa0JBQWtCO1lBQ25GLFFBQVEsRUFBRSw0Q0FBNEM7U0FDdkQ7S0FDRjtDQUNGLENBQUEifQ==